var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolidUserAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.9375C11.8291 9.9375 13.7188 8.04785 13.7188 5.71875C13.7188 3.38965 11.8291 1.5 9.5 1.5C7.1709 1.5 5.28125 3.38965 5.28125 5.71875C5.28125 8.04785 7.1709 9.9375 9.5 9.9375ZM13.25 10.875H11.6357C10.9854 11.1738 10.2617 11.3438 9.5 11.3438C8.73828 11.3438 8.01758 11.1738 7.36426 10.875H5.75C3.67871 10.875 2 12.5537 2 14.625V15.0938C2 15.8701 2.62988 16.5 3.40625 16.5H15.5938C16.3701 16.5 17 15.8701 17 15.0938V14.625C17 12.5537 15.3213 10.875 13.25 10.875Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidUserAlt);
export default __webpack_public_path__ + "static/media/icon-solid-user-alt.bc215db7612be42e4ce036f9b395b579.svg";
export { ForwardRef as ReactComponent };